// extracted by mini-css-extract-plugin
export var checkboxContainer = "styles-module__checkboxContainer___DLJzt";
export var mobile = "styles-module__mobile___BcDjs";
export var containerColumns = "styles-module__containerColumns___RP3m5";
export var columnSection = "styles-module__columnSection___o3xiW";
export var alignRight = "styles-module__alignRight___iHLWv";